import React from 'react';
import { useMutation, useQuery, useQueryClient } from 'react-query';
import { brokerApi } from 'services/apis';
import { useParams } from 'react-router';
import { BrokerForm } from '../broker-form';
import { ReplaceBrokerPayloadDto } from 'libs/pinnacle-sdk';
import dayjs from 'dayjs';
import { EQueryKeys } from 'constants/query-keys';

const UpdateBrokerForm: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const queryClient = useQueryClient();

  const { data: broker, isLoading: isFetchingBroker } = useQuery(
    [EQueryKeys.BROKER_BY_ID, id],
    () => brokerApi.getBrokerById({ brokerId: id as string }),
    {
      enabled: !!id,
    }
  );

  const updateBrokerMutation = useMutation<
    void,
    Error,
    { broker: ReplaceBrokerPayloadDto; fileIds: string[] }
  >(async ({ broker, fileIds }) => {
    await brokerApi.replaceBroker({
      brokerId: id as string,
      replaceBrokerPayloadDto: {
        ...broker,
        fileIds,
      },
    });
    queryClient.invalidateQueries([EQueryKeys.BROKER_BY_ID, id]);
  });

  return (
    <BrokerForm
      mode="update"
      initialData={
        broker
          ? {
              ...broker,
              tobaCompletionDate: broker.tobaCompletionDate
                ? dayjs(broker.tobaCompletionDate)
                : undefined,
              kycCompletionDate: broker.kycCompletionDate
                ? dayjs(broker.kycCompletionDate)
                : undefined,
              website: broker.website?.replace('https://', ''),
            }
          : undefined
      }
      files={broker?.files}
      onSubmit={updateBrokerMutation.mutateAsync}
      isLoading={isFetchingBroker || updateBrokerMutation.isLoading}
    />
  );
};

export default UpdateBrokerForm;
